/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ServiceItemsListService } from './../services/serviceitems.service';
import { CustomerPreferenceResponse } from './../../../preference/customerpreference.model';
import { CustomerPreferenceService } from './../../../preference/customerpreference.service';
declare var $: any;

@Component({
    selector: 'zsd-services',
    templateUrl: '../view/serviceitems.component.html',
    encapsulation: ViewEncapsulation.None
})

export class ServiceItemsComponent implements OnInit {
    isFilterOpen: boolean;
    showServiceCatalogTab: boolean;
    servicesCount: String;
    constructor(private customerPreferenceService: CustomerPreferenceService,
        private itemsService: ServiceItemsListService) {

    }

    ngOnInit() {
        window.scrollTo(0, 0);
        this.initServicePreferencesAndCount();
    }

    initServicePreferencesAndCount(): void {
        // get privilege for service catalog
        this.customerPreferenceService.getPreferenceList().toPromise()
            .then((preference: CustomerPreferenceResponse) => {
                this.showServiceCatalogTab = preference.showAllService;

                // get count for  myservice and servicecatalog list
            if (!this.showServiceCatalogTab) {
                this.itemsService.getServiceCount().subscribe((val: number) => {
                this.servicesCount = '(' + val + ')';
                });
            }
            });
    }

    openFilter() {
        this.isFilterOpen = true;
        $('#services_filterpanel_control').width('100%');
        $('body').css('overflow-y', 'hidden');
    }
}
